/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import { FormControlLabel, Checkbox, Snackbar, Divider } from "@material-ui/core";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import { Alert } from "@material-ui/lab";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogHeader from "../dialog/functional/DialogHeader";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import AutoForm from "../form/functional/AutoForm";
import MomSysUglOrderBuyerDetailStandard from "../screens/MomSysUglOrderBuyerDetailStandard";

const useStyles = makeStyles((theme) => ({

    keepOpenSwitch: {
        marginLeft: "8px"
    },

    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text
    },

}));

function MomSysOrderBuyerDetailDialog ( props ) {

    const {

        id,
        schema,
        
        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onClose,
        onInitialized,
        onSuccess,

        title,
        formId,

        onDialogUpdateDetail,
        onSelectMst,
        modifyUrlCallback,

        customizeErrorMsgCallback,
        onChangeStandardSchema,
        modifyFormDataCallback,

        ...others

    } = props;

    const  classes = useStyles ();
    const { t } = useTranslation ();

    const [instance, setInstance] = useState ();
    const [formData, setFormData] = useState({});
    const [keepOpen, setKeepOpen] = useState(false);
    const [interaction, setInteraction] = useState(false);
    const [material, setMaterial] = useState([]);
    const [updateSchema, setUpdateSchema] = useState(schema);
    const [modellingFile, setModellingFile] = useState({deletedFiles: Array(0), activeFiles: Array(0)});
    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    useEffect(() => {

        if (schema) {

            let columnMap = {};

            for (const column of schema.columns) {

                columnMap[column.name] = column;

            }

            schema.columnMap = columnMap;

        }

        setUpdateSchema(schema);

    }, [schema]);

    const checkItemValidataion = ( schema, formData, onSelectMst, material ) => {

        for ( const column of schema.columns ) {

            let [valid, msg] = checkValidation ( "create", column, column.validation, formData[column.name] || "" );

            if ( !valid ) {

                nofifyWarning ( msg );
                return false;

            }
            
        }

        if ( material.opCode === "PUR" && ( onSelectMst.modelName !== material.modelName || onSelectMst.modelPartName !== material.modelPartName)) {

            nofifyWarning ( t ( "error.notMacthPURMaterialModelNameOrModelPartName", {modelName: onSelectMst.modelName, modelPartName: onSelectMst.modelPartName, materialModelName: material.modelName, materialModelPartName: material.modelPartName} ) );
            return false;

        }

        return true;

    }

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onNotifySuccess = ( msg ) => {

        notifySuccess ( msg );

        if ( onDialogUpdateDetail ) {

            onDialogUpdateDetail();

        }

    };

    const nofifyWarning = (msg) => {

        console.warn (msg);

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const notifyFailure = (msg) => {

        console.error ( msg );

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    useEffect(() => {

        setFormData ( ( formData ) => {

            for ( let column of schema.columns) {

                if ( column.defaultValue !== undefined ) {
                    
                    formData[column.name] = column.defaultValue;
                    
                }
    
            }

            return formData;

        } );

    }, [])

    useEffect ( () => {

        if ( material.standard ) {

            setFormData ( ( formData ) => {
    
                let newFormData = {
    
                    ...formData,
                    orderBuyerId: onSelectMst.orderBuyerId,
                    modelName: onSelectMst.modelName,
                    modelPartName: onSelectMst.modelPartName,
                    materialCode: material.materialCode,
                    materialCodeVer: material.materialCodeVer,
                    materialName: material.materialName,
                    itemSpecName: material.itemSpecName,
                    itemUnitName: material.itemUnitName,
                    partNo: material.partNo,
                    partSeq: material.partSeq,
                    opCode: material.opCode,
                    cutCode1: material.cutCode1,
                    cutCode2: material.cutCode2,
                    material: material.material,
                    t_size: 0,
                    w_size: 0,
                    l_size: 0,
                    t_delta: 0,
                    w_delta: 0,
                    l_delta: 0,
                    t_grinding: 0,
                    w_grinding: 0,
                    l_grinding: 0,
                    qty: 1,
                    standard: material.standard,
                    productionCategory: t("term.ownCompany"),
    
                };

                return newFormData;
    
            } );

        } else {

            setFormData ( ( formData ) => {
    
                let newFormData = {
    
                    ...formData,
                    orderBuyerId: onSelectMst.orderBuyerId,
                    modelName: onSelectMst.modelName,
                    modelPartName: onSelectMst.modelPartName,
                    materialCode: material.materialCode,
                    materialCodeVer: material.materialCodeVer,
                    materialName: onSelectMst.modelName + "/" + onSelectMst.modelPartName,
                    itemSpecName: material.itemSpecName,
                    itemUnitName: material.itemUnitName,
                    partNo: null,
                    partSeq: null,
                    opCode: material.opCode,
                    cutCode1: null,
                    cutCode2: null,
                    material: null,
                    t_size: 0,
                    w_size: 0,
                    l_size: 0,
                    t_delta: 0,
                    w_delta: 0,
                    l_delta: 0,
                    t_grinding: 0,
                    w_grinding: 0,
                    l_grinding: 0,
                    qty: 1,
                    standard: material.standard,
                    productionCategory: t("term.ownCompany"),
    
                };

                return newFormData;
    
            } );

        }

        setUpdateSchema ( onChangeStandardSchema ( schema, material.standard ) );

    }, [material, onSelectMst, schema] );

    const onDialogInitialized = ( instance ) => {

        setInstance(instance);

        if ( onInitialized ) {

            onInitialized ( instance );

        }

    };

    const onApiSuccess = (result) => {

        setKeepOpen ( ( keepOpen ) => {

            if ( !keepOpen ) {

                instance.hide();

            }

            if  ( onSuccess ) {

                setTimeout ( ( ) =>  onSuccess ( result.data ), 0 );
    
            } else {

                onNotifySuccess ( result.data );

            }

            return keepOpen;

        } );

    };

    const onApiFailure = (reason) => {

        if ( customizeErrorMsgCallback ) {

            notifyFailure ( customizeErrorMsgCallback ( reason ) );

        } else {

            notifyFailure ( t ( "error.insertFailure", { reason: reason.response ? reason.response.data : JSON.stringify ( reason ) } ) );

        }

    };

    const onOk = ( schema, formData, onSelectMst, material, modellingFile ) => {

        if ( ! checkItemValidataion ( schema, formData, onSelectMst, material ) ) {

            console.error ( "Form Validation Failed" );

            return;

        }

        if (schema.validation) {

            let [valid, msg] = checkConditionWithMsg(

                formData,
                schema.validation

            );

            if (!valid) {

                nofifyWarning ( t ( "warning.formDataValidationFail", { msg: msg } ) );
                return;

            }

        }

        // build base api url

        let url = `/api/${schema.name}`;

        if ( modifyUrlCallback ) {

            url = modifyUrlCallback( url );

        }

        let apiData = { ...formData, modellingFile: modellingFile };
            
        let form = new FormData ();

        let json = {};
        let deleted = {};

        for ( const formItem in apiData ) {

            if ( schema.columnMap && schema.columnMap[formItem] && schema.columnMap[formItem].formItemType === "file" ) {

                deleted[formItem] = apiData[formItem].deletedFiles;
                    
                for ( const file of apiData[formItem].activeFiles ) {

                    if ( file.type === "url" ) continue;

                    form.append ( formItem, file.file );

                }

            } else {

                if ( apiData[formItem] !== undefined ) {

                    json[formItem] = apiData[formItem];

                }

            }

        }

        form.append ( "deleted", JSON.stringify ( deleted ) );
        form.append ( "json", JSON.stringify ( json ) );

        apiClient
            .post(url, form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((result) => onApiSuccess(result))
            .catch((reason) => onApiFailure(reason));

    }

    const onCancel = () => {

        setMaterial([]);

        instance.hide();

    };

    const  checkKeepOpen = () => {

        return (
            <>

                <FormControlLabel
                    control={

                        <Checkbox
                            className={classes.keepOpenSwitch}
                            checked={keepOpen}
                            color="primary"
                            onChange={ ()=> setKeepOpen( ( keepOpen ) => ( !keepOpen ) ) }
                            name="checkKeepOpen"
                            size="small"
                        />
                    }
                    label={<span className={classes.label}>{t("term.keepDialogOpen")}</span>}
                />
                <div style={{flexGrow: 1}}></div>

            </>

        )

    }

    const onChange = ( formData ) => {

        setInteraction(true);

        setFormData ( formData );

    }

    const onCloseNotification = () => {

        setNotification( ( notification ) => {

            return ({...notification, open: false});

        } );

    };

    const onCloseDialog = () => {

        setInteraction(false);

        setMaterial([]);

        setFormData ( ( formData ) => {

            let newFormData = {
                ...formData,
                partNo: null,
                partSeq: null,
                opCode: null,
                cutCode1: null,
                cutCode2: null,
                material: null,
                t_size: 0,
                w_size: 0,
                l_size: 0,
                t_delta: 0,
                w_delta: 0,
                l_delta: 0,
                t_grinding: 0,
                w_grinding: 0,
                l_grinding: 0,
                qty: 0,
                description: null,
                productionCategory: null,
            }

            return newFormData;

        } );
        
        if ( onClose ) {

            onClose ();

        }
    }

    const onSetMaterial = ( material ) => {

        setMaterial(material);

    }

    const onModifyFormDataCallback = ( newFormData, name, value ) => {

        if ( modifyFormDataCallback ) {

            modifyFormDataCallback ( newFormData, name, value );

        }

        if ( name === "modellingFile" ) {

            setModellingFile ( value );

        }

    }

    return (
        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth="lg"
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >

            <DialogHeader>
                <DialogTitle>
                    { title }
                </DialogTitle>
            </DialogHeader>

            <Divider />

            <DialogContent style={{padding: "0px", height: "600px"}}>

                <ReflexContainer orientation="vertical">

                    <ReflexElement flex={0.5} >

                        <MomSysUglOrderBuyerDetailStandard
                            onSetMaterial={onSetMaterial}
                        />

                    </ReflexElement>

                    <ReflexSplitter
                        style={{width: "1px",color:"lightgray"}}
                    />

                    <ReflexElement flex={0.5} >

                        <div
                            style={{
                                padding: "16px"
                            }}                    
                        >

                            <AutoForm
                                id="order-buyer-detail-create-form"
                                schema={updateSchema}
                                mode="edit"
                                initialData={formData}
                                onChange={onChange}
                                modifyFormDataCallback={onModifyFormDataCallback}
                            />

                        </div>

                    </ReflexElement>

                </ReflexContainer>

                <Snackbar
                    open={notification.open && notification.severity !== "success"}
                    autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                    onClose={onCloseNotification}
                >
                    <Alert
                        onClose={onCloseNotification}
                        variant="filled"
                        severity={notification.severity}
                    >

                        {notification.msg}

                    </Alert>

                </Snackbar>

            </DialogContent>

            <Divider />

            <DialogActionsOkCancel
                firstActionComponent={checkKeepOpen}
                labels={[ t("common.add")]}
                buttonDisabled={[!interaction, false]}
                onOk={() => onOk(updateSchema, formData, onSelectMst, material, modellingFile)}
                onCancel={onCancel}
            />

        </Dialog>

    );

}

export default MomSysOrderBuyerDetailDialog;
